"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when object is in an invalid state
 * @param {string} explanation
 */
class InvalidStateError extends ExtendableError_1.default {
    constructor(explanation = '') {
        super(`Invalid state. ${explanation}`);
        this.explanation = explanation;
    }
}
exports.default = InvalidStateError;
